import React from 'react';
import './SelectedElementMessage.css';

function SelectedElementMessage({ updateSelectedElement }) {
  return (
    <div className="selected-element-message-container">
      Uspješno ste označili element.
      <button
        className="selected-element-message-button"
        onClick={() => {
          updateSelectedElement();
          window.popup.hide();
        }}
      >
        Potvrdi odabir
      </button>
    </div>
  );
}

export default SelectedElementMessage;
